import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Redirect, Route } from "react-router-dom";
import { closeToastDialog } from "./actions/progress";
import ProtectedRoute from "./components/GeneralComponents/ProtectedRoute";
import ToastDialog from "./components/GeneralComponents/ToastDialog/ToastDialog";
import React, { Suspense } from "react";

const ResetPasswordPage = React.lazy(() =>
  import("./pages/ResetPasswordPage/ResetPasswordPage")
);
const RegistrationPage = React.lazy(() =>
  import("./pages/RegistrationPage/RegistrationPage")
);
const LoginPage = React.lazy(() => import("./pages/LoginPage/LoginPage"));
const JobListPage = React.lazy(() => import("./pages/JobListPage/JobListPage"));
const EquipmentTrackingPage = React.lazy(() =>
  import("./pages/EquipmentTrackingPage/EquipmentTrackingPage")
);
const MaterialOwnerListPage = React.lazy(() =>
  import("./pages/MaterialOwnerListPage/MaterialOwnerListPage")
);
const ProfileSettingsPage = React.lazy(() =>
  import("./pages/ProfileSettingsPage/ProfileSettingsPage")
);
const ReportsPage = React.lazy(() => import("./pages/ReportsPage/ReportsPage"));
const ReturnedToShopPage = React.lazy(() =>
  import("./pages/ReturnedToShopPage/ReturnedToShopPage")
);
const ToolTrackingPage = React.lazy(() =>
  import("./pages/ToolTrackingPage/ToolTrackingPage")
);
const VendorListPage = React.lazy(() =>
  import("./pages/VendorPage/vendorListPage")
);
const DataVisualizationPage = React.lazy(() =>
  import("./pages/DataVisualizationPage/DataVisualizationPage")
);
const OnTheWay = React.lazy(() => import("./pages/ShopPage/onTheWay"));
const ArchivedRecordsPage = React.lazy(() =>
  import("./pages/ArchivedRecordsPage/ArchivedRecordsPage")
);
const equipmentTrackingAllJobsPage = React.lazy(() =>
  import("./pages/equipmentTrackingAllJobsPage/EquipmentTrackingAllJobsPage")
);

function AppRouter() {
  const user = useSelector((state) => state.auth.user);
  const {
    isLoading,
    loadingList,
    isToastDialogOpen,
    toastDialogMessage,
    toastDialogType,
  } = useSelector((state) => state.progress);
  const isVerifying = useSelector((state) => state.auth.isVerifying);

  return (
    <div style={{ overflow: "hidden" }}>
      <Suspense
        fallback={
          <div className="generalProgress">
            <CircularProgress />
          </div>
        }
      >
        {loadingList.length > 0 && (
          <div className="generalProgress">
            <CircularProgress />
          </div>
        )}
        <ToastDialog
          open={isToastDialogOpen}
          onClose={closeToastDialog}
          // onOpen={openToastDialog}
          message={toastDialogMessage}
          type={toastDialogType}
        />

        <Router>
          <ProtectedRoute
            exact
            path="/"
            component={OnTheWay}
            user={user}
            isVerifying={isVerifying}
          >
            <Redirect to="/equipmentTrackingAllJobs" />{" "}
          </ProtectedRoute>
          <Route path="/login" component={LoginPage} />
          <Route path="/signup" component={RegistrationPage} />
          <Route path="/forgotpassword" component={ResetPasswordPage} />
          <ProtectedRoute
            path="/otw"
            component={OnTheWay}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/back"
            component={OnTheWay}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/here"
            component={OnTheWay}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/leaving"
            component={OnTheWay}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/materialList"
            component={OnTheWay}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/jobList"
            component={JobListPage}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/materialOwnerList"
            component={MaterialOwnerListPage}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/vendorList"
            component={VendorListPage}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/archivedRecords"
            component={ArchivedRecordsPage}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/equipmentTracking/:id"
            component={EquipmentTrackingPage}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/equipmentTrackingAllJobs"
            component={equipmentTrackingAllJobsPage}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/returnedToShop"
            component={ReturnedToShopPage}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/toolTracking"
            component={ToolTrackingPage}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/reports"
            component={ReportsPage}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/dataVisualization"
            component={DataVisualizationPage}
            user={user}
            isVerifying={isVerifying}
          />
          <ProtectedRoute
            path="/profileSettings"
            component={ProfileSettingsPage}
            user={user}
            isVerifying={isVerifying}
          />
        </Router>
      </Suspense>
    </div>
  );
}

export default AppRouter;
